var _style, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSoundBars = function SvgSoundBars(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .spinner_7uc5 {\r\n      animation: spinner_3l8F 1.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite;\r\n      animation-delay: -0.9s;\r\n    }\r\n    .spinner_RibN {\r\n      animation-delay: -0.7s;\r\n    }\r\n    .spinner_ZAxd {\r\n      animation-delay: -0.5s;\r\n    }\r\n    @keyframes spinner_3l8F {\r\n      0% {\r\n        opacity: 0.8;\r\n      }\r\n      66.66% {\r\n        opacity: 0.9;\r\n      }\r\n      0%, 66.66% {\r\n        animation-timing-function: cubic-bezier(0.14, 0.73, 0.34, 1);\r\n        y: 8px; /* Adjusted from 6px to 8px */\r\n        height: 8px; /* Adjusted from 12px to 8px */\r\n      }\r\n      33.33% {\r\n        animation-timing-function: cubic-bezier(0.65, 0.26, 0.82, 0.45);\r\n        y: 4px; /* Adjusted from 1px to 4px */\r\n        height: 16px; /* Adjusted from 22px to 16px */\r\n        opacity: 0.9;\r\n      }\r\n      100% {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_7uc5 spinner_RibN",
    x: 6.5,
    y: 8,
    width: 2.8,
    height: 8,
    rx: 1.4,
    ry: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_7uc5",
    x: 10.1,
    y: 8,
    width: 2.8,
    height: 8,
    rx: 1.4,
    ry: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "spinner_7uc5 spinner_ZAxd",
    x: 13.7,
    y: 8,
    width: 2.8,
    height: 8,
    rx: 1.4,
    ry: 1.4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSoundBars);
export { ForwardRef as ReactComponent };